
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premium/welcome",
      function () {
        return require("private-next-pages/premium/welcome.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premium/welcome"])
      });
    }
  